import CategoryTree from './src/main';

/* istanbul ignore next */
CategoryTree.install = function(Vue) {
  Vue.component(CategoryTree.name, CategoryTree);
};

/**
 * TODO
 * 1. 全选同级(多语言)
 * 2. 不支持选择根分类 (多语言)
 * */

export default CategoryTree;
